import * as React from "react";
import classnames from "classnames";
import { stringToInt, intToString } from "../../../converters/converters";
import { LevelGroup, CheckboxGroup } from "../Forms/Groups";
import { Polyglot } from "../../../polyglot";
import { FormItemHorizontal } from "../Forms/FormItemHorizontal";
import { Select } from "../../../components/Select";

interface Axle
{
    id: number;
    name: string;
}

export interface LevelsProps
{
    polyglot: Polyglot;
    isBaselineVisible?: boolean;
    unitName: string;
    
    axle: number;
    axleCount: number;
    baseline?: number;
    defineAlertLevels?: boolean;
    redMax: number;
    redMin: number;
    yellowMax: number;
    yellowMin: number;
    
    setAxle: (axle: number) => void;
    setBaseline?: (v: number) => void;
    setDefineAlertLevels?: (flag: boolean) => void;
    setRedMax: (v: number) => void;
    setRedMin: (v: number) => void;
    setYellowMax: (v: number) => void;
    setYellowMin: (v: number) => void;
}

export class Levels extends React.Component<LevelsProps, any>
{
    render()
    {
        const {
            isBaselineVisible, unitName,
            defineAlertLevels, setDefineAlertLevels,
            baseline, setBaseline,
            redMax, setRedMax,
            redMin, setRedMin,
            yellowMax, setYellowMax,
            yellowMin, setYellowMin,
            polyglot,
        } = this.props;
        const maxUnitName = isBaselineVisible ? '+%' : unitName;
        const minUnitName = isBaselineVisible ? '-%' : unitName;

        const axles: Axle[] = createAxleOptions(polyglot, this.props.axleCount);

        return (
            <div className="form-horizontal">
                <FormItemHorizontal title={polyglot.t('levels.axles') + ':'} labelColumns={4}>
                    <Select className='form-control'
                        placeholder="---"
                        items={axles}
                        titleFn={(axle: Axle) => axle.name}
                        valueFn={(axle: Axle) => axle.id.toString()}
                        onChange={s => this.props.setAxle(parseInt(s.getValue())) }
                        defaultValue={this.props.axle ? this.props.axle.toString() : null}
                    />
                </FormItemHorizontal>

                { isBaselineVisible &&
                    <LevelGroup title={polyglot.t('levels.baseline') + ':'} unitName={unitName} value={intToString(baseline, true)} onChange={e => setBaseline(stringToInt(e.target.value, true))} />
                }
                { isBaselineVisible &&
                    <CheckboxGroup title={polyglot.t('levels.define_alert_levels')} checked={this.props.defineAlertLevels} onChange={e => setDefineAlertLevels(e.target.checked)}/>
                }
                <LevelGroup title={polyglot.t('levels.red_max') + ':'} unitName={maxUnitName} value={intToString(redMax, true)} onChange={e => setRedMax(stringToInt(e.target.value, true))} disabled={isBaselineVisible && !defineAlertLevels} />
                <LevelGroup title={polyglot.t('levels.yellow_max') + ':'} unitName={maxUnitName} value={intToString(yellowMax, true)} onChange={e => setYellowMax(stringToInt(e.target.value, true))} disabled={isBaselineVisible && !defineAlertLevels}/>
                <LevelGroup title={polyglot.t('levels.yellow_min') + ':'} unitName={minUnitName} value={intToString(yellowMin, true)} onChange={e => setYellowMin(stringToInt(e.target.value, true))} disabled={isBaselineVisible && !defineAlertLevels}/>
                <LevelGroup title={polyglot.t('levels.red_min') + ':'} unitName={minUnitName} value={intToString(redMin, true)} onChange={e => setRedMin(stringToInt(e.target.value, true))} disabled={isBaselineVisible && !defineAlertLevels}/>
            </div>
        );
    }
}

function createAxleOptions(polyglot: Polyglot, axleCount: number)
{
    const axles = [-1];
    for(let i=1; i <= axleCount; i++) {
        axles.push(i);
    }
    return axles.map(id => ({
        id,
        name: (id > 0) ? `${polyglot.t('levels.axle_#')} ${id}` : polyglot.t('levels.all_axles')
    }));    
}


// WEBPACK FOOTER //
// ./src/app/components/Levels/Levels.tsx